<div class="sign-status invalid">
  <div class="icon-wrapper">
    <mat-icon>link_off</mat-icon>
  </div>

  <h2>Link not valid</h2>

  <p>
    This signing link is invalid or has expired.
    Please contact the sender to request a new link.
  </p>

  <!--<button mat-raised-button color="primary">
    Contact Sender
  </button>-->
</div>
